module.exports = __webpack_public_path__ + "static/media/ball.8416369f.png";